<template>
  <div>
    <div class="realbody">
      <div class="container" style="margin-top: 100px;">
        <div class="row">
          <div class="col-md-12 mainbody text-center">
            <h6 class="gray cocogothic spacing3-2 mgtop10">INPUT PROFILE and SKILL</h6>
            <p class="r_panel_title mplus2p-r spacing4 black" style="margin-top: 30px;">次にあなたのITスキルをスコア化してみましょう。</p>
            <p class="mplus2p-r spacing1-2 black" style="font-size: 0.75rem;">以下の質問にお答えください。</p>
            <form style="margin-top: 30px;" name="form">
              <div class="row text-center statuspanel">
                <div class="col-md-3 totalcol">
                  <p class="cocogothic spacing3-2 noiseblack statustitle">TOTAL</p>
                  <div class="chartboxes">
                    <h3 class="mplus2p-r noiseblack statusnum" id="total">{{model.total}}</h3>
                    <canvas baseChart [data]="totalD"
                            [colors]="totalC"
                            [chartType]="doughnutChartType"
                            [options]="chartOptions"></canvas>
                  </div>
                </div>
                <div class="col-md-3">
                  <p class="cocogothic spacing3-2 noiseblack statustitle">Technical</p>
                  <div class="chartboxes">
                    <h3 class="mplus2p-r noiseblack statusnum" id="technical">{{model.technical}}</h3>
                    <canvas baseChart [data]="technicalD" [colors]="technicalC" [chartType]="doughnutChartType"
                            [options]="chartOptions"></canvas>
                  </div>
                </div>
                <div class="col-md-3">
                  <p class="cocogothic spacing3-2 noiseblack statustitle">Management</p>
                  <div class="chartboxes">
                    <h3 class="mplus2p-r noiseblack statusnum" id="management">{{model.management}}</h3>
                    <canvas baseChart [data]="managementD" [colors]="managementC" [chartType]="doughnutChartType"
                            [options]="chartOptions"></canvas>
                  </div>
                </div>
                <div class="col-md-3">
                  <p class="cocogothic spacing3-2 noiseblack statustitle">Business</p>
                  <div class="chartboxes">
                    <h3 class="mplus2p-r noiseblack statusnum" id="business">{{model.business}}</h3>
                    <canvas baseChart [data]="businessD" [colors]="businessC" [chartType]="doughnutChartType"
                            [options]="chartOptions"></canvas>
                  </div>
                </div>
              </div>
              <div class="row qaboxes text-left" style="margin-top: 45px;">
                <div class="col-md-12 paddings">
                  <p class="mplus2p-m spacing1-2 qtitle"><span style="font-size: 1.3rem;">Q.</span>
                    質問が入ります質問が入ります質問が入ります質問が入ります質問が入ります</p>
                </div>
                <div class="col-md-12 paddings">
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m1" name="a"/>
                    <label for="m1" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m2" name="a"/>
                    <label for="m2" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m3" name="a"/>
                    <label for="m3" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m4" name="a"/>
                    <label for="m4" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m5" name="a"/>
                    <label for="m5" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                </div>
              </div>
              <div class="row qaboxes text-left">
                <div class="col-md-12 paddings">
                  <p class="mplus2p-m spacing1-2 qtitle">
                    <span style="font-size: 1.3rem;">Q.</span> 質問が入ります質問が入ります質問が入ります質問が入ります質問が入ります</p>
                </div>
                <div class="col-md-12 paddings">
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m11" name="b"/>
                    <label for="m11" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m12" name="b"/>
                    <label for="m12" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m13" name="b"/>
                    <label for="m13" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m14" name="b"/>
                    <label for="m14" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                  <div style="float: left;">
                    <input class="medium" type="radio" id="m15" name="b"/>
                    <label for="m15" class="mplus2p-m radiolabel black spacing1-2">オプション</label>
                  </div>
                </div>
              </div>
              <div class="row text-left" style="margin-top: 10px;">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                  <button class="btn bluebtn mplus2p-r spacing1-2 regnext_btn">次へ</button>
                  <p class="skipbtn mplus2p-m spacing1-2 blue">スキップ</p>
                </div>
                <div class="col-md-3"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        chartOptions: {responsive: true, cutoutPercentage: 80},
        doughnutChartType: "doughnut",

        totalC: [
          {
            backgroundColor: ["#3d7dd8", "white"],
            borderColor: ["#3d7dd8", "transparent"]
          }
        ],
        technicalC: [
          {
            backgroundColor: ["#3dd8ca", "white"],
            borderColor: ["#3dd8ca", "transparent"]
          }
        ],
        managementC: [
          {
            backgroundColor: ["#853dd8", "white"],
            borderColor: ["#853dd8", "transparent"]
          }
        ],
        businessC: [
          {
            backgroundColor: ["#60d6ec", "white"],
            borderColor: ["#60d6ec", "transparent"]
          }
        ],

        totalD: [],
        technicalD: [],
        managementD: [],
        businessD: [],

        model: {}
      };
    },
    created() {
      this.model.total = 100;
      this.model.technical = 5;
      this.model.management = 25;
      this.model.business = 70;

      this.totalD = [this.model.total, 100 - this.model.total];
      this.technicalD = [this.model.technical, 100 - this.model.technical];
      this.managementD = [this.model.management, 100 - this.model.management];
      this.businessD = [this.model.business, 100 - this.model.business];

      this.doCenter();
    },
    methods: {
      doCenter() {

        let txtheight, txtwidth;
        if ($(window).width() <= 975 && $(window).width() >= 751) {
          $("#total").css("font-size", "1rem");
          $("#technical").css("font-size", "1rem");
          $("#management").css("font-size", "1rem");
          $("#business").css("font-size", "1rem");
          txtwidth = [10.44, 20.88, 31.3];
          txtheight = 40;
        } else {
          $("#total").css("font-size", "1.5rem");
          $("#technical").css("font-size", "1.5rem");
          $("#management").css("font-size", "1.5rem");
          $("#business").css("font-size", "1.5rem");
          txtwidth = [15.66, 31.3, 46.95];
          txtheight = 28;
        }

        const ttrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
        const ttrightright =
          ($(".chartboxes").width() -
            txtwidth[this.model.total.toString().length - 1]) /
          2;
        $("#total").css("margin-top", ttrighttop.toString() + "px");
        $("#total").css("margin-left", ttrightright.toString() + "px");

        const thrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
        const thrightright =
          ($(".chartboxes").width() -
            txtwidth[this.model.technical.toString().length - 1]) /
          2;
        $("#technical").css("margin-top", thrighttop.toString() + "px");
        $("#technical").css("margin-left", thrightright.toString() + "px");

        const mgrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
        const mgrightright =
          ($(".chartboxes").width() -
            txtwidth[this.model.management.toString().length - 1]) /
          2;
        $("#management").css("margin-top", mgrighttop.toString() + "px");
        $("#management").css("margin-left", mgrightright.toString() + "px");

        const birighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
        const birightright =
          ($(".chartboxes").width() -
            txtwidth[this.model.business.toString().length - 1]) /
          2;
        $("#business").css("margin-top", birighttop.toString() + "px");
        $("#business").css("margin-left", birightright.toString() + "px");
      },

      doRegisterSecond() {
      }
    }
  };
</script>

<style scoped>
  .mainbody:after {
    position: absolute;
    content: url("../../../assets/imgs/zoomtool.png");
    top: -1px;
    right: 60px;
    margin-top: 25px;
  }

  .regselectboxs {
    float: left;
    margin-left: 16px;
  }

  .reglabels {
    font-size: 0.875rem;
    font-weight: 600;
    padding: 20px 0;
  }

  .regradioboxs {
    text-align: center;
    min-width: 145px;
    height: 50px;
    float: left;
    background-color: #ffffff;
    border: 1px solid #b4bec8;
    color: #b4bec8;
    margin-left: 16px;
    margin-top: 5px;
    padding-top: 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  .manradio:hover,
  .mchosen {
    border: 1px solid #3d7dd8;
    color: #3d7dd8;
  }

  .womenradio:hover,
  .wchosen {
    border: 1px solid #f878c8;
    color: #f878c8;
  }

  .regradiotxt {
    font-size: 0.875rem;
    font-weight: bold;
  }

  .regnext_btn {
    width: 100%;
    height: 56px;
    margin-top: 50px;
    font-weight: bold;
    font-size: 1rem;
  }

  .skipbtn {
    margin-top: 25px;
    font-weight: bold;
    font-size: 1rem;
    text-align: center;
  }

  .selectdiv select {
    height: 50px !important;
  }

  .sexerror {
    margin-top: 60px;
    margin-bottom: 20px;
    margin-left: 16px;
  }

  @media screen and (max-width: 1200px) {
    .mainbody:after {
      right: 20px;
    }

    .regselectboxs {
      float: left;
      margin-left: 5px;
    }

    .regradioboxs {
      margin-left: 5px;
    }

    .sexerror {
      margin-left: 5px;
    }
  }

  @media screen and (max-width: 992px) {
    .mainbody:after {
      right: -20px;
    }

    .regselectboxs {
      float: left;
      width: 100%;
    }

    regradioboxs {
      margin-left: 16px;
    }
  }

  .statuspanel {
    background-color: #f8f8fa;
  }

  .statustitle {
    font-size: 1.25rem;
    font-weight: bold;
    margin-top: 34px;
    margin-bottom: 0.1rem;
  }

  .radiolabel {
    font-size: 0.875rem;
    font-weight: 500;
  }

  input[type="radio"] {
    appearance: none;
    margin: 0 20px;
    width: 16px;
    height: 16px;
    background: #f0f2f4;
    box-shadow: inset 0 0 0 0em white, 0 0 0 0.05em;
    border-radius: 50%;
    transition: 0.2s;
    cursor: pointer;
    color: #dcdee0;
  }

  input[type="radio"]:hover,
  input[type="radio"]:checked {
    background: #3d7dd8;
    box-shadow: inset 0 0 0 0.6em white, 0 0 0 0.3em;
  }

  input[type="radio"]:checked {
    background: #3d7dd8;
    box-shadow: inset 0 0 0 0.15em white, 0 0 0 0.1em #3d7dd8;
  }

  input[type="radio"]:focus {
    outline: 0;
  }

  .paddings {
    padding: 0px 150px;
  }

  .qtitle {
    font-size: 0.875rem;
    margin-left: 19px;
    font-weight: 500;
  }

  .qaboxes {
    margin-top: 30px;
  }

  .chartboxes {
    display: block;
    margin: auto;
    margin-bottom: 30px;
    max-width: 200px;
    height: 100px;
  }

  .statusnum {
    position: absolute;
    /*right: 46%;
      top: 55%;*/
    font-weight: bold;
    font-size: 1.5rem;
  }

  .totalcol::after {
    content: "";
    border-left: 2px solid #e4e4e6;
    position: absolute;
    height: 84%;
    right: 0;
    top: 8%;
  }

  @media screen and (max-width: 1200px) {
    .paddings {
      padding: 0px 50px;
    }
  }

  @media screen and (max-width: 992px) {
    .paddings {
      padding: 0px 0px;
    }
  }

  @media screen and (max-width: 768px) {
    .mainbody:after {
      right: -60px;
    }

    .totalcol::after {
      content: "";
      border-left: 2px solid transparent;
      position: absolute;
      height: 84%;
      right: 0;
      top: 8%;
    }
  }

  @media screen and (max-width: 678px) {
    .mainbody:after {
      right: 0px;
      margin-top: -60px;
    }

    .mainbody {
      margin-top: 40px;
    }
  }

  @media screen and (max-width: 369px) {
    .regradioboxs {
      margin-top: 10px;
      width: 100%;
      margin-left: 0px;
    }
  }
</style>
